import { TASK_PRIORITIES } from 'Data/common-constants.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  return TASK_PRIORITIES
}
